import { TextLink as TextLinkImpl, type TextLinkProps } from '../../../../../../mads/TextLink';
import { navigateView } from '../../../../../native-module/navigateView';
import { useViewjobSourceUrl } from '../../../../context/ViewJobDataContext';

import { useCallback } from 'react';
import { Platform } from 'react-native';

export interface Props extends TextLinkProps {
    shareMessage?: string;
    shareUrl?: string;
    targetUrl: string;
}

export function TextLink(props: Props): React.JSX.Element {
    // Custom link handling to navigate in ViewJob.
    const vjUrl = useViewjobSourceUrl();
    const handlePress = useCallback(async () => {
        await navigateView(
            vjUrl,
            props.targetUrl,
            props.shareUrl ?? props.targetUrl,
            props.shareMessage,
        );
        if (props.onPress) {
            props.onPress();
        }
    }, [props, vjUrl]);

    const onPress = useCallback(() => {
        void handlePress();
    }, [handlePress]);

    const { targetUrl, ...restProps } = props;

    if (Platform.OS === 'web') {
        return <TextLinkImpl {...restProps} targetUrl={targetUrl} webHrefAttrs={{ target: '_blank' }} />;
    } else {
        // Don't pass targetUrl to TextLinkImpl, instead rely on it being handled here.
        return <TextLinkImpl {...restProps} onPress={onPress}  />;
    }
}
